<template>
<div class="flex flex-col items-center h-screen bg-cover font-mono text-xs md:text-sm" :style="{
        'background-image': `linear-gradient(rgba(0, 0, 0, 0.8), rgba(0, 0, 0, 0.8)), url(${w < 550 ? bgSrc.sm : bgSrc.lg})`,
      }">
    <Header class="pb-16 md:pb-32  md:hidden" :cart="cart" :cartAnimation="cartAnimation" @refresh-cart="$emit('refresh-cart', $event)" />
    <div class="text-left text-gray-300 mt-12 md:hidden">
        <div class="p-1.5 shadow-lg">
            <router-link class="hover:bg-white hover:text-black" to="/news"> news </router-link>
        </div>
        <div class="p-1.5 shadow-lg">
            <router-link class="hover:bg-white hover:text-black" to="/preview"> spring/summer 2021 preview </router-link>
        </div>
        <div class="p-1.5 shadow-lg">
            <router-link class="hover:bg-white hover:text-black" to="/lookbook"> spring/summer 2021 lookbook </router-link>
        </div>
        <div class="p-1.5 shadow-lg">
            <router-link class="hover:bg-white hover:text-black" to="/shop-preview"> shop </router-link>
        </div>
        <div class="p-1.5 shadow-lg">
            <router-link class="hover:bg-white hover:text-black" to="/lifestyle"> lifestyle </router-link>
        </div>
        <div class="p-1.5 shadow-lg">
            <router-link class="hover:bg-white hover:text-black" to="/about-us"> about </router-link>
        </div>
        <div class="p-1.5 shadow-lg">
            <router-link class="hover:bg-white hover:text-black" to="/mailing-list"> mailing list </router-link>
        </div>
        <div class="p-1.5 shadow-lg">
            <router-link class="hover:bg-white hover:text-black" to="/contact-us"> contact </router-link>
        </div>
        <div class="flex justify-center mt-10 text-gray-400 text-opacity-70">
            <a href="https://www.facebook.com/ambra.st.official/" class="md:flex-col how-social trans-04 mr-1 ml-1 mb-5">
                <font-awesome-icon :icon="{ prefix: 'fab', iconName: 'facebook' }" />
            </a>

            <a href="https://instagram.com/ambra.world" class="md:flex-col how-social trans-04 mr-1 ml-1 mb-5">
                <font-awesome-icon :icon="{ prefix: 'fab', iconName: 'instagram' }" />
            </a>

            <a href="https://www.youtube.com/channel/UCNxtDvPL6t9w03tNzja0xVA/" class="md:flex-col how-social trans-04 mr-1 ml-1 mb-5">
                <font-awesome-icon :icon="{ prefix: 'fab', iconName: 'youtube' }" />
            </a>
            <a href="https://www.youtube.com/channel/UCNxtDvPL6t9w03tNzja0xVA/" class="md:flex-col how-social trans-04 mr-1 ml-1 mb-5">
                <font-awesome-icon :icon="{ prefix: 'fab', iconName: 'twitter' }" />
            </a>
        </div>
    </div>
    <LandingMenu class="hidden md:block"/>
</div>
</template>

<script>
import Header from '../components/Header';
import LandingMenu from '../components/LandingMenu.vue';
import {
    library
} from '@fortawesome/fontawesome-svg-core';
import {
    faFacebook,
    faInstagram,
    faYoutube,
    faTwitter
} from '@fortawesome/free-brands-svg-icons';
library.add(faFacebook, faInstagram, faYoutube, faTwitter);
const bgImages = [{
        sm: require('../assets/bg/bg01s.jpg'),
        lg: require('../assets/bg/bg01.jpg')
    },
    {
        sm: require('../assets/bg/bg02s.jpg'),
        lg: require('../assets/bg/bg02.jpg')
    },
    {
        sm: require('../assets/bg/bg03s.jpg'),
        lg: require('../assets/bg/bg03.jpg')
    }
];
export default {
    name: "LandingPage",
    components: {
        Header,
        LandingMenu
    },
    data() {
        return {
            cart: null,
            cartAnimation: false,
            bgSrc: bgImages[Math.floor(Math.random() * 3)],
            w: window.innerWidth
        };
    },
};
</script>
